// 搜集所有的vuex模块，再导出
import admin from './admin'
import web from './web'
import user from './user'
import active from './active'
export default {
  admin, web, user, active
}
